import { render, staticRenderFns } from "./AtendimentoPorCriticidade.vue?vue&type=template&id=654786ea&scoped=true&"
import script from "./AtendimentoPorCriticidade.vue?vue&type=script&lang=js&"
export * from "./AtendimentoPorCriticidade.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoPorCriticidade.vue?vue&type=style&index=0&id=654786ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654786ea",
  null
  
)

export default component.exports